import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/laboratorial_analysis/new',
  title: 'Cadastrar Análise Laboratorial',
  endpoint: '/app/laboratory_analysis',
}
